module.exports = __webpack_public_path__ + "files/a9f7beeb11d3a67146a07aefe424da6f.png";